var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.864 4.652C16.333 3.073 14.339 2.203 12.25 2.203C10.159 2.203 8.16502 3.073 6.63302 4.653C5.07802 6.257 4.22402 8.412 4.29102 10.566C4.48002 16.67 11.67 21.423 11.977 21.622L12.246 21.797L12.518 21.625C12.824 21.431 20.019 16.793 20.209 10.565C20.275 8.412 19.42 6.256 17.864 4.652Z",
    fill: "#B0D1E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51294 10.7589C9.51294 12.2679 10.7409 13.4949 12.2499 13.4949C13.7589 13.4949 14.9859 12.2679 14.9859 10.7589C14.9859 9.24985 13.7589 8.02185 12.2499 8.02185C10.7409 8.02185 9.51294 9.24985 9.51294 10.7589Z",
    fill: "#004B7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.954797039c590882ed2dfe22f34dc583.svg";
export { ForwardRef as ReactComponent };